import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  HomeIcon,
  PuzzlePieceIcon,
  UsersIcon,
  CreditCardIcon,
  BanknotesIcon,
  ChartBarIcon,
  Cog6ToothIcon,
  DocumentTextIcon,
  ClockIcon,
  UserGroupIcon,
  ArrowsRightLeftIcon,
} from '@heroicons/react/24/outline';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const navigation = [
  { id: 'dashboard', label: 'Dashboard', icon: <HomeIcon className="w-4 h-4" />, path: '/dashboard' },
  { id: 'game-management', label: 'Game Management', icon: <PuzzlePieceIcon className="w-4 h-4" />, path: '/game-management' },
  { id: 'game-history', label: 'Game History', icon: <ClockIcon className="w-4 h-4" />, path: '/game-history' },
  { id: 'users', label: 'Users', icon: <UsersIcon className="w-4 h-4" />, path: '/users' },
  { id: 'credit', label: 'Credit', icon: <CreditCardIcon className="w-4 h-4" />, path: '/credit' },
  { id: 'withdraw', label: 'Withdraw', icon: <BanknotesIcon className="w-4 h-4" />, path: '/withdraw' },
  { id: 'transfers', label: 'Transfers', icon: <ArrowsRightLeftIcon className="w-4 h-4" />, path: '/transfers' },
  { id: 'referrals', label: 'Referrals', icon: <UserGroupIcon className="w-4 h-4" />, path: '/referrals' },
  { id: 'post', label: 'Post', icon: <DocumentTextIcon className="w-4 h-4" />, path: '/post' },
  { id: 'financial-management', label: 'Financial Management', icon: <ChartBarIcon className="w-4 h-4" />, path: '/financial-management' },
  { id: 'platform-settings', label: 'Platform Settings', icon: <Cog6ToothIcon className="w-4 h-4" />, path: '/platform-settings' },
     { id: 'settings', label: 'Settings', icon: <Cog6ToothIcon className="w-4 h-4" />, path: '/settings' },
];

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      <aside
        className={`
          fixed top-0 left-0 h-full w-56 bg-primary-500 text-black z-50
          transform transition-transform duration-300 ease-in-out
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
          lg:translate-x-0 lg:static lg:z-auto
          shadow-sidebar
          flex flex-col
        `}
      >
        {/* Logo */}
        <div className="flex items-center justify-center py-4 px-4 border-b border-primary-600 flex-shrink-0">
          <img
            src="/fav_icon.png"
            alt="Logo"
            className="w-20 h-20 object-contain"
          />
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-3 py-3 space-y-0.5 overflow-y-auto">
          {navigation.map((item) => (
            <NavLink
              key={item.id}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center px-3 py-2 text-xs font-medium rounded-lg
                transition-all duration-200 cursor-pointer
                ${
                  isActive
                    ? 'bg-secondary-500 text-white shadow-md'
                    : 'text-black hover:bg-primary-400 hover:text-black'
                }`
              }
              onClick={() => {
                if (window.innerWidth < 1024) onClose();
              }}
            >
              <span className="mr-2.5 flex-shrink-0">
                {item.icon}
              </span>

              <span className="flex-1">
                {item.label}
              </span>
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;